export default {
	home: {
		name: ""
	},
	page_out_trade_no: "マーチャント注文番号"
};
